import { render, staticRenderFns } from "./TicketMessageForm.vue?vue&type=template&id=3890e5e4&"
import script from "./TicketMessageForm.vue?vue&type=script&lang=js&"
export * from "./TicketMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./TicketMessageForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports